import PatientActionWrapper from "../../PatientActionWrapper";
import SummaryContentLayout from "./SummaryContentLayout";

export default PatientActionWrapper(SummaryContentLayout);
